import {
  HttpContextToken,
  HttpEvent,
  HttpHandlerFn,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Observable, of, tap } from 'rxjs';
import { API_REQUEST_TYPES } from '../constants/api.request.type.constants';

// Cache storage
export const cache = new Map<string, HttpResponse<unknown>>();

// Context token to enable caching for specific requests
export const CACHING_ENABLED = new HttpContextToken<boolean>(() => false);

export function cachingInterceptor(
  request: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {
  // Only cache GET requests if caching is enabled
  const isCachingEnabledForRequest =
    request.method === API_REQUEST_TYPES.GET && request.context.get(CACHING_ENABLED);
  if (isCachingEnabledForRequest) {
    const cachedResponse = cache.get(request.urlWithParams);
    if (cachedResponse) {
      return of(cachedResponse.clone());
    }
  }

  return next(request).pipe(
    tap((event) => {
      if (event instanceof HttpResponse && isCachingEnabledForRequest) {
        cache.set(request.urlWithParams, event.clone());
      }
    }),
  );
}

export function removeCacheByUrlPattern(urlPattern: string): number {
  let deletedCount = 0;
  const keysToDelete: string[] = [];

  for (const key of cache.keys()) {
    if (key.includes(urlPattern)) {
      keysToDelete.push(key);
    }
  }

  keysToDelete.forEach((key) => {
    if (cache.delete(key)) {
      deletedCount++;
    }
  });

  return deletedCount;
}
